<template>
  <div class="cq-result">
    <div class="cq-result-panel">
      <div class="cq-result-toolbar">
        <Button type="primary" icon="md-refresh" @click="getData">刷新</Button>&nbsp;&nbsp;
        <Button type="primary" icon="md-download" @click="exportExcel">导出excel</Button>
      </div>
      <Table :height="tableHeight" :columns="tableColumns" :data="rows" :loading="loading" border stripe></Table>
      <div class="cq-result-page-bar">
        <span class="tpl-total">共 {{ total }} 条记录</span>
        <Page :total="total" :current="pageNo" :page-size="pageSize" :page-size-opts="pageSizeOpts"
          @on-change="onPageChange" @on-page-size-change="onPageSizeChange" show-sizer show-elevator transfer />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'query-result',
  props: {
    api: {
      type: Object,
      required: true
    },
    // 执行查询的配置（来自配置页）
    payload: {
      type: Object,
      default: null
    },
    // 从历史模版执行时的模版 id
    templateId: {
      type: String,
      default: ''
    },
    // 从历史模版执行时的模版名称
    templateName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100],
      loading: false,
      columns: [],
      rows: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tableHeight: 500 // 表格可视高度(px)，固定表头并出现纵向滚动条；随窗口自适应
    }
  },
  computed: {
    tableColumns() {
      let seq = { title: '序号', type: 'index', width: 70, align: 'center' }
      let dynamic = this.columns.map(c => Object.assign({ align: 'center', tooltip: true, minWidth: 100 }, c))
      return [seq].concat(dynamic)
    }
  },
  created() {
    this.getPageSizeOpts()

  },
  mounted() {
    this.updateTableHeight()
    window.addEventListener('resize', this.updateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableHeight)
  },
  methods: {
    // 通过字典 ZD_CUSTOM_PAGEZISE 动态获取分页选项
    getPageSizeOpts() {
      if (typeof this.api.getPageSizeOpts !== 'function') return
      this.api.getPageSizeOpts().then(opts => {
        if (opts && opts.length > 0) {
          this.pageSizeOpts = opts
          this.pageSize = opts[0]
        }
        this.getData()
      }).catch(() => {
        this.getData()
        // 接口异常时保持默认值
      })
    },
    // 计算表格可视高度，iView Table 的 height 需为像素数值方可固定表头并出现滚动条
    updateTableHeight() {
      this.tableHeight = Math.round(window.innerHeight * 0.85)
    },
    getData() {
      this.loading = true
      // 从模版执行时优先带上 templateId，供真实接口按模版查询
      let payload = this.payload || {}
      if (this.templateId) {
        payload = Object.assign({}, payload, { templateId: this.templateId, templateName: this.templateName })
      }
      this.api
        .executeQuery(payload, this.pageNo, this.pageSize)
        .then(resp => {
          console.log('executeQuery resp', resp)
          this.columns = resp.columns || []
          this.rows = resp.rows || []
          this.total = resp.total || 0
          if (resp && resp.success) {
          } else {
            resp && resp.msg ? this.$Message.error((resp && resp.msg) || '查询失败') : ''
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    onPageSizeChange(size) {
      this.pageSize = size
      this.pageNo = 1
      this.getData()
    },
    exportExcel() {
      if (typeof this.api.exportData !== 'function') {
        this.$Message.info('导出功能待接入')
        return
      }
      let payload = this.payload || {}
      if (this.templateId) {
        payload = Object.assign({}, payload, { templateId: this.templateId, templateName: this.templateName })
      }
      Promise.resolve(this.api.exportData(payload)).catch(err => {
        this.$Message.error((err && err.message) || '导出失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cq-result {
  padding: 12px;
}

.cq-result-panel {
  background: #fff;
  border-radius: 4px;
  padding: 16px 20px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.cq-result-toolbar {
  text-align: right;
  margin-bottom: 12px;
}

.cq-result-page-bar {
  text-align: right;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/views/query-result.vue